export default __webpack_public_path__ + "static/direct-consumer.url-03abf9554bccfe59ab53a01a9a8fd752.svg";